import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { BackToShop } from "./BackToShop";
import { GlobalTrustBadge } from "./trust/GlobalTrustBadge";
import { InstallAppButton } from "./InstallAppButton";
import { fetchCategories } from "../lib/api";

export const Layout = ({ children }) => {
  const [categories, setCategories] = useState([]);
  const { pathname } = useLocation();

  useEffect(() => {
    fetchCategories().then(setCategories).catch(() => setCategories([]));
  }, []);

  // Hide the floating badge on admin/login screens
  const hideTrustBadge = pathname.startsWith("/admin");

  return (
    <div className="min-h-screen flex flex-col grain bg-bl-bg" data-testid="app-layout">
      <Header categories={categories} />
      <main className="flex-1">{children}</main>
      <Footer categories={categories} />
      <BackToShop />
      {!hideTrustBadge && <GlobalTrustBadge />}
      {!hideTrustBadge && <InstallAppButton />}
    </div>
  );
};
